export const words = {
  logo: "Habdout",
  li: ["home", "pages", "menu", "shop", "blog", "contact"],
  button: "ORDER ONLINE",
  update: "update menu's item",
  chicken: "chickensup burger",
  welcome: "Welcome",
  burgerWithyummi: "Burger With Yummy Test Real Love",
  lorem:
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit sed do eusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida.",
  Explore: " Explore History",

  listOfCarousel: [
    "integrated with mushroom",
    " cheese integrated",
    " bacon flavour",
  ],

  quality: "Quality Products",
  Expected: "Burgers As Expected Dilicious One",
  tabs: [0, 1, 2, 3],
  Pricing: "Pricing Lists",
  Choose: "Choose & Order Now!",
  Photos: "Photos",
  Gallery: "Our Food Gallery",
  Quality: "Quality Products",
  Burgers: "Burgers As Expected Dilicious One",
  delivery: "delivery",
  deliveryTitle: "What You Want To Select A Pick Up Through Online",
  deliverydec:
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit sed do eusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida.",
  deliveryButton: "Order Now",
  deliveryBlackButton: "EARN COIN",
};
